import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableRow,
} from "@mui/material";
import "leaflet-polylinedecorator";

const convertDateISOToUTC = (isoDate) => {
  if (isoDate !== null && isoDate !== "") {
    return new Date(isoDate).toLocaleString();
  } else return "";
};

const style = (feature) => {
  let type = feature.properties.type;
  const defaultStyle = {
    weight: 4,
    opacity: 0.8,
    fillOpacity: 0.3,
  };

  if (type === "Clear") {
    return {
      ...defaultStyle,
      color: "transparent",
      fillColor: "transparent",
      weight: 4,
    };
  }
  if (type === "Seasonal") {
    return {
      ...defaultStyle,
      color: "transparent",
      fillColor: "transparent",
      weight: 4,
    };
  }
  if (type === "Partially covered by snow") {
    return {
      ...defaultStyle,
      color: "#818DB3",
      fillColor: "#818DB3",
      weight: 4,
    };
  }
  if (type === "Partly covered by ice or snow") {
    return {
      ...defaultStyle,
      color: "#818DB3",
      fillColor: "#818DB3",
      weight: 4,
    };
  }
  if (type === "Partly covered by ice") {
    return {
      ...defaultStyle,
      color: "#818DB3",
      fillColor: "#818DB3",
      weight: 4,
      dashArray: "5 10",
    };
  }
  if (type === "Mostly Covered by snow or ice") {
    return {
      ...defaultStyle,
      color: "#3078c1ff",
      fillColor: "#3078c1ff",
      weight: 4,
    };
  }
  if (type === "All covered by snow") {
    return {
      ...defaultStyle,
      color: "#FFB6D9",
      fillColor: "#FFB6D9",
      weight: 4,
    };
  }
  if (type === "All covered by snow or ice") {
    return {
      ...defaultStyle,
      color: "#FFB6D9",
      fillColor: "#FFB6D9",
      weight: 4,
    };
  }
  if (type === "All Covered by Ice") {
    return {
      ...defaultStyle,
      color: "#FFB6D9",
      fillColor: "#FFB6D9",
      weight: 4,
      dashArray: "5 10",
    };
  }
  if (type === "Travel Not Advised") {
    return { ...defaultStyle, color: "purple", fillColor: "purple", weight: 4 };
  }
  if (type === "Impassible or closed") {
    return {
      ...defaultStyle,
      color: "red",
      fillColor: "red",
      weight: 4,
      dashArray: "5 10",
    };
  }
  if (type === "Towing Not Recommended") {
    return {
      ...defaultStyle,
      color: "#ADD8E6",
      fillColor: "#ADD8E6",
      weight: 4,
    };
  }

  return { ...defaultStyle, color: "#808080", fillColor: "#808080" };
};

const WinterRoadConditions = (props) => {
  const feature = props.feature;
  const properties = feature.properties;
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardHeader
        title={<font className="layer-title"> {properties.type} </font>}
        className={"styledtablerow"}
        sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
      />
      <CardContent
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        <Table size="small">
          <TableRow className="layertablecellLeft">
            <div style={{ marginBottom: "8px", marginTop: "8px" }}>
              Location - {properties.location}
            </div>
            <div style={{ marginBottom: "8px" }}>
              {" "}
              City/County - {properties.adminLevel2}
              {properties.adminLevel2 ? ", " : ""}
              {properties.state}{" "}
            </div>
            <div style={{ marginBottom: "8px" }}>
              {" "}
              {`Last Updated: ${convertDateISOToUTC(properties.lastUpdateTime)}`}{" "}
            </div>
          </TableRow>
        </Table>
      </CardContent>
    </Card>
  );
};

const PopupTemplate = (props) => {
  const feature = props.feature;
  return <WinterRoadConditions feature={feature} />;
};

const LegendTemplate = (props) => {
  const url = process.env.PUBLIC_URL + "/mapicons/WinterRoadConditions/WRC.png";

  return (
    <Box sx={{ display: "flex", height: "60px" }}>
      <Box sx={{ ml: 8, display: "flex" }}>
        <Box
          sx={{
            backgroundImage: `url(${url})`,
            backgroundSize: "contain",
            width: "250px",
            backgroundRepeat: "no-repeat",
          }}
        ></Box>
      </Box>
    </Box>
  );
};

const filter = (feature) => {
  const type = feature.properties.type;
  return type !== "Clear" && type !== "Seasonal";
};

const module = {
  name: "Winter Road Conditions",
  endpoint: "/winterConditionMap.json",
  showOnMap: true,
  polygonLayer: true,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL + "/mapicons/WinterRoadConditions/snow.png",
  LegendTemplate: LegendTemplate,
  maxZoom: 5,
  defaultOn: false,
  zIndex: 650,
  style: style,
  filter: filter,
};

export default module;
